import React, { useMemo } from 'react'
import NextLink from 'next/link'

import { Button } from '@wartek-id/button-v1'

import { PraktikKinerjaStepCard } from 'app/KinerjaShared/components/PraktikKinerjaStepCard'

import type { StepCardStatus } from 'app/KinerjaShared/components/PraktikKinerjaStepCard'
import type { StepProgressData } from 'app/KinerjaShared/components/PraktikKinerjaPegawaiStepCards/types'

type ObservasiStepCardProps<TStep extends string = string> = {
  className?: string
  description: React.ReactNode
  imagePath: string
  lockedHint?: string
  nextPath: string
  progressData?: StepProgressData<TStep>
  sortedSteps: Array<TStep>
  step: TStep
  title: React.ReactNode
}

export function ObservasiStepCard<TStep extends string = string>({
  className,
  description,
  imagePath,
  lockedHint = 'Dilakukan setelah isi Diskusi Persiapan.',
  nextPath,
  progressData = {},
  sortedSteps,
  step,
  title,
}: ObservasiStepCardProps<TStep>) {
  const stepCardStatus: StepCardStatus = useMemo(() => {
    const currentStepIndex = sortedSteps.indexOf(progressData.step)
    const observasiStepIndex = sortedSteps.indexOf(step)

    if (currentStepIndex > observasiStepIndex) return 'completed'
    if (currentStepIndex === observasiStepIndex) return 'active'

    return 'locked'
  }, [progressData.step, sortedSteps, step])

  return (
    <PraktikKinerjaStepCard
      className={className}
      actions={
        <NextLink href={nextPath} passHref>
          <Button
            as="a"
            size="lg"
            color={stepCardStatus === 'active' ? 'blue' : 'white'}
            className="!inline-flex"
            type={undefined}
          >
            Cek rincian
          </Button>
        </NextLink>
      }
      description={description}
      iconSrc={imagePath}
      lockedHint={lockedHint}
      status={stepCardStatus}
      title={title}
    />
  )
}
